export default {
    'name': 'dash-big',
    'width': '48',
    'height': '48',
    'viewBox': '0 0 48 48',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M40 23H8V25H40V23Z\' fill=\'#026958\'/>'
}
